<script>
import { mapGetters } from 'vuex'
import Creative from './edit/Creative'
import Questions from './edit/Questions'
import Results from './edit/Results'
import Settings from './edit/Settings'

export default {

    name: 'edit-quiz',

    components: {[Creative.name]: Creative, [Questions.name]: Questions, [Results.name]: Results, [Settings.name]: Settings,},

    computed: {
        ...mapGetters({
            dirty: 'quizFormIsDirty'
        }),


        isCreativeValid()
        {
            return false
        },

        isQuestionsValid()
        {
            return false
        },

        isResultsValid()
        {
            return false
        },

        isSettingsValid()
        {
            return false
        },
    },

    data(){
        return {
            quiz:null,
            menu: [
                {
                    name:'Creative',
                    slug:'creative',
                    done: false,
                },
                {
                    name:'Questions',
                    slug:'questions',
                    done: false,
                },
                {
                    name:'Results',
                    slug:'results',
                    done: false,
                },
                {
                    name:'Settings',
                    slug:'settings',
                    done: false,
                },
            ],
            isNameEdit: false,
            slug: null,
            page:null,
        }
    },

    methods: {
        setData()
        {
            this.slug = this.$route.params.item
            this.page = this.$route.params.slug
            this.fetch()
            this.validation()
        },

        fetch()
        {
            this.$store.dispatch('quizFetchById', this.slug).then(res => {
                this.quiz = res
            })
        },

        saveName()
        {
            this.save()
            this.isNameEdit = false
        },

        save()
        {
            this.$store.dispatch('quizUpdate', {name: this.quiz.name, id : this.quiz.id}).then( res => {
                this.quiz = res
                this.validation()
            })
        },
        saveAll()
        {
            this.$store.dispatch('quizUpdate', this.quiz).then( res => {
            })
        },

        validation()
        {
            if (this.isCreativeValid) {
                this.menu[0].done = true
            } else {
                this.menu[0].done = false
            }
            if (this.isQuestionsValid) {
                this.menu[1].done = true
            } else {
                this.menu[1].done = false
            }
            if (this.isResultsValid) {
                this.menu[2].done = true
            } else {
                this.menu[2].done = false
            }
            if (this.isSettingsValid) {
                this.menu[3].done = true
            } else {
                this.menu[3].done = false
            }
            if (this.isCreativeValid && this.isSettingsValid && this.isQuestionsValid && this.isResultsValid) {
                this.quiz.is_valid = true
                this.setValid()
            } else {
                if (this.quiz)
                    this.quiz.is_valid = false
            }
        },

        setValid()
        {
            this.$store.dispatch('quizUpdate', Object.assign({}, this.quiz, { is_valid: true }))
        }
    },

    mounted()
    {
        this.setData()
    },

    // beforeRouteLeave(to, from, next) {
    //     if (this.dirty)
    //     {
    //         this.$store.dispatch('quizRedirectTo', to)
    //         this.$refs.confirmModal.openModal()
    //         next(false)
    //     } else {
    //         this.$store.dispatch('quizRedirectTo', null)
    //         next()
    //     }
    // },
    //
    // beforeRouteUpdate (to, from, next) {
    //     if (this.dirty)
    //     {
    //         this.$store.dispatch('quizRedirectTo', to)
    //         this.$refs.confirmModal.openModal()
    //         next(false)
    //     } else {
    //         this.$store.dispatch('quizRedirectTo', null)
    //         next()
    //     }
    // }
}
</script>

<template lang="html">
    <div>
        <confirm-modal withRedirect ref="confirmModal"></confirm-modal>
        <div class="py-3">
            <router-link class="text-desc-color text-lg" :to="{ name: 'quizzes'}">
                <i class="fas fa-long-arrow-alt-left mr-2"></i> All products
            </router-link>
        </div>
        <simple-panel class="mb-3">
            <div class="d-flex d-flex justify-content-start p-3">
                <template v-if="!isNameEdit">
                    <h2 class="text-h2-lg mb-0 mr-2 font-weight-semibold">
                        Pick the Perfect Wedding Ring
                    </h2>
                    <custom-button classes="mini border-radius-2 grey text-desc-color mr-3" @buttonClick="isNameEdit=true" iconBeforeText="fas fa-pencil-alt"></custom-button>
                </template>
                <template v-else>
                    <div>
                        <simple-input
                        class="mr-2 mw-300"
                        type="text"
                        v-model="quiz.name"
                        placeholder="Type a name"
                        noRadius
                        ></simple-input>
                        <custom-button classes="xs border-radius-2 blue text-white mr-3" @buttonClick="saveName" iconBeforeText="fas fa-save"></custom-button>
                    </div>
                </template>

                <div class="pt-1">
                    <span class="font-weight-bold mr-1">ID</span>
                    <span>#QU598</span>
                </div>
            </div>
        </simple-panel>
        <!-- v-if="quiz" -->
        <panel-wrapper class="mb-2 quiz-edit" isProgression  routerName="quiz-edit" :slug="page" :menu="menu" @switched="saveAll">
            <div slot="panel-wrapper-content">
                <div v-if="page=='creative'">
                    <create-quiz-creative @saved="validation" :quiz="quiz"></create-quiz-creative>
                </div>

                <div v-if="page=='questions'">

                </div>

                <div v-if="page=='results'">

                </div>

                <div v-if="page=='settings'">

                </div>
            </div>
        </panel-wrapper>
        <div class="text-right text-placeholder-color" v-if="quiz">
            Last modified
            <template v-if="quiz.updated_at">
                <template v-if=" $moment.utc(quiz.updated_at, 'YYYY-MM-DD HH:mm:ss').diff($moment(), 'days') > 0" >
                    {{ quiz.updated_at | toDate }}
                </template>
                <template v-else>
                    {{ $moment.utc(quiz.updated_at, 'YYYY-MM-DD HH:mm:ss').fromNow() }}
                </template>
            </template>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// src/pages/tools/quizzes/Edit.vue